import { useEffect, useState } from 'react';

import { FEATURE_FLAGS } from '../common/context/FlagsContext';
import { useFeatureFlagsValue } from '../common/context/FlagsValueContext';
import { getFeaturesByClientId } from '../utils/getFeaturesByClientId';

export function useEnablePostSignIn2faEnrollment() {
  const [enablePostSignIn2faEnrollment, setEnablePostSignIn2faEnrollment] = useState(false);
  const flagsContext = useFeatureFlagsValue();
  useEffect(() => {
    const { isPostSignIn2faEnrollmentEnabled } = getFeaturesByClientId();
    const enabled =
      flagsContext?.flags?.find(v => v?.flagKey === FEATURE_FLAGS.ENABLE_POST_SIGNIN_2FA_ENROLLMENT?.toString())
        ?.flagValue ?? false;
    setEnablePostSignIn2faEnrollment(enabled && isPostSignIn2faEnrollmentEnabled);
  }, [flagsContext]);

  return { enablePostSignIn2faEnrollment };
}
